// Página de e-commerce
// Muestra el catálogo de productos, gestión de productos y órdenes de compra
// Integra componentes de gestión de productos (ABM), catálogo de compras y tabla de órdenes

import ProductManagement from '../components/ProductManagement';
import ProductCatalog from '../components/ProductCatalog';
import OrdersTable from '../../../../components/ecommerce/OrdersTable';
import { useOrders } from '../../../../hooks/useOrders';
import { consultarEstadoPago, mapearEstadoPago } from '../../../../utils/mercadoPagoApi';
import { actualizarEstadoOrden } from '../../../../services/ordenesService';

export default function EcommercePage() {
	// Hook para gestionar órdenes
	const {
		orders,
		isLoading,
		isError,
		error,
		hasNextPage,
		totalCount,
		searchText,
		estadoFilter,
		orderBy,
		currentOffset,
		loadNextPage,
		resetToFirstPage,
		handleSearchChange,
		handleEstadoChange,
		handleOrderByChange,
		refresh
	} = useOrders();

	/**
	 * Verifica el estado de un pago en Mercado Pago y actualiza la orden
	 * @param {string} ordenId - ID de la orden en Supabase
	 * @param {string} paymentId - ID del pago o preferencia en Mercado Pago
	 */
	const handleVerificarPago = async (ordenId, paymentId) => {
		try {
			console.log(`🔍 Verificando pago ${paymentId} para orden ${ordenId}`);
			
			// Verificar si es un preference_id (no se puede verificar directamente)
			if (!paymentId || paymentId.startsWith('mp_preference_id') || paymentId.length < 10) {
				alert('Esta orden no tiene un payment_id de Mercado Pago aún. No se puede verificar el estado.');
				return;
			}
			
			// Consultar estado en Mercado Pago a través de Edge Function
			const resultado = await consultarEstadoPago(paymentId);
			
			if (!resultado.success) {
				alert(`Error consultando Mercado Pago: ${resultado.message}`);
				return;
			}
			
			// Usar el estado mapeado que devuelve la Edge Function
			const nuevoEstado = resultado.nuevoEstado || mapearEstadoPago(resultado.status);
			
			// Actualizar orden en Supabase
			await actualizarEstadoOrden(ordenId, nuevoEstado, {
				mp_status: resultado.status,
				mp_payment_id: paymentId,
				metadata: resultado.data
			});
			
			// Mostrar resultado al usuario
			const mensajeEstado = resultado.status === 'approved' 
				? '✅ El pago fue APROBADO en Mercado Pago' 
				: resultado.status === 'rejected'
				? '❌ El pago fue RECHAZADO en Mercado Pago'
				: resultado.status === 'cancelled'
				? '⚠️ El pago fue CANCELADO en Mercado Pago'
				: `ℹ️ Estado en Mercado Pago: ${resultado.status}`;
			
			alert(`${mensajeEstado}\nEstado local actualizado a: ${nuevoEstado}`);
			
			// Refrescar la tabla
			refresh();
			
		} catch (error) {
			console.error('Error verificando pago:', error);
			alert(`Error verificando pago: ${error.message}`);
		}
	};

	return (
    <article className='p-4'>
			<div className="max-w-7xl mx-auto">
				{/* Título de la página */}
				<div className="mb-8">
					<h1 className="text-3xl font-bold text-white light:text-gray-900">
						E-commerce
					</h1>
				</div>

				{/* Catálogo de Productos */}
				<div className="mb-8">
					<h2 className="text-2xl font-semibold text-white light:text-gray-900 mb-4">
						Catálogo de Productos
					</h2>
					<ProductCatalog />
				</div>

				{/* Gestión de Productos (ABM) */}
				<div className="mb-8">
					<h2 className="text-2xl font-semibold text-white light:text-gray-900 mb-4">
						Gestión de Productos (ABM)
					</h2>
					<ProductManagement />
				</div>

				{/* Órdenes de Compra */}
				<div className="mb-8">
					<h2 className="text-2xl font-semibold text-white light:text-gray-900 mb-4">
						Órdenes de Compra
					</h2>
					<OrdersTable
						orders={orders}
						isLoading={isLoading}
						isError={isError}
						error={error}
						hasNextPage={hasNextPage}
						totalCount={totalCount}
						searchText={searchText}
						estadoFilter={estadoFilter}
						orderBy={orderBy}
						currentOffset={currentOffset}
						onLoadNextPage={loadNextPage}
						onSearchChange={handleSearchChange}
						onEstadoChange={handleEstadoChange}
						onOrderByChange={handleOrderByChange}
						onResetPage={resetToFirstPage}
						onRefresh={refresh}
						onVerificarPago={handleVerificarPago}
					/>
				</div>
			</div>
    </article>
	)
}
